/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type MoreProjects_tradeFirm = {
    readonly name: string | null;
    readonly publicProfile: {
        readonly designProjectsCover: ReadonlyArray<{
            readonly serviceId: string | null;
            readonly name: string | null;
            readonly coverPhoto: string | null;
            readonly url: string | null;
        } | null> | null;
    } | null;
    readonly " $refType": "MoreProjects_tradeFirm";
};
export type MoreProjects_tradeFirm$data = MoreProjects_tradeFirm;
export type MoreProjects_tradeFirm$key = {
    readonly " $data"?: MoreProjects_tradeFirm$data;
    readonly " $fragmentRefs": FragmentRefs<"MoreProjects_tradeFirm">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "MoreProjects_tradeFirm",
  "type": "TradeFirmType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "publicProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmPublicProfileType",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "designProjectsCover",
          "storageKey": null,
          "args": null,
          "concreteType": "DesignProjectCover",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "serviceId",
              "args": null,
              "storageKey": null
            },
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "coverPhoto",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "url",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '37689c38103031353fc545cdf32fc36f';
export default node;
